export default "__VITE_ASSET__BspRlxve__"